import React from 'react';

export function IconPremium(props: {
    width?: number | string;
    height?: number | string;
    stroke?: string;
}) {
    return  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 25}
    height={props.height ?? 25}
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      stroke={props.stroke ?? '#fff'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.06 3.77c.13-.24.44-.33.68-.2.08.05.15.11.2.2l2.95 5.6a.992.992 0 0 0 1.52.29L21.69 6c.21-.17.53-.14.7.07.1.12.14.29.09.45l-2.83 10.25c-.12.43-.51.73-.96.73H6.31c-.45 0-.84-.3-.96-.73L2.52 6.52c-.07-.27.08-.54.35-.61.16-.04.32 0 .45.09L7.6 9.66a1.008 1.008 0 0 0 1.52-.29l2.95-5.61-.01.01ZM5.5 21.5h14M12.49 13h.01"
    />
  </svg>;
}

/**
 * Inline crown that marks RxDB Premium features inside text,
 * scaled to the font size of the surrounding text.
 * The crown is drawn over a widened non-breaking space so that
 * a surrounding link underlines it like the link text.
 */
export function PremiumIcon() {
    return <span
        className="premium-icon"
        role="img"
        aria-label="RxDB Premium"
        title="RxDB Premium"
    >
        <span className="premium-icon-spacer" aria-hidden="true">{'\u00A0'}</span>
        <span className="premium-icon-svg" aria-hidden="true">
            <IconPremium width="100%" height="100%" stroke="currentColor" />
        </span>
    </span>;
}
